import { SVGAttributes } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import SVGIcon, { SVGIconProps } from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'

const logoVariants = cva(
  ['block', 'transition-colors duration-500 ease-in-out-cubic'],
  {
    variants: {
      variant: {
        small: 'h-[9rem] w-[13.8rem]',
        large: 'h-[10rem] w-[15.3rem] md:h-[11rem] md:w-[16.8rem]'
      },
      theme: {
        light: 'fill-light',
        dark: 'fill-dark'
      }
    },
    defaultVariants: {
      variant: 'large',
      theme: 'dark'
    }
  }
)

export type LogoProps = SVGAttributes<SVGSVGElement> &
  VariantProps<typeof logoVariants> &
  Pick<SVGIconProps, 'symbol'>

const Logo = ({
  variant,
  symbol = 'logo',
  theme,
  className,
  ...props
}: LogoProps) => {
  return (
    <SVGIcon
      symbol={symbol}
      className={cn(logoVariants({ variant, theme, className }))}
      {...props}
    />
  )
}

export default Logo
